import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubscription } from "../redux/action/subscriptionAction";
import Loader from "../components/other/Loader";
import NoRecord from "../components/other/NoRecord";
import { pipViewDate2 } from "../utils/pip";
import ReactPagination from "../components/reactPagination";
import PaginationDropdown from "../components/PaginationDropdown";

const Subscriptions = () => {
  const dispatch = useDispatch();
  const { isToggle } = useSelector((state) => state.authReducer);
  const { isLoading, allSubscription } = useSelector(
    (state) => state.subscriptionReducer
  );
  const [filterCriteria, setFilterCriteria] = useState({
    plan_name: "",
    plan_type: "",
    searchQuery: "",
  });
  const [filteredSubscriptions, setFilteredSubscriptions] = useState([]);
  const [subscriptionCounts, setSubscriptionCounts] = useState({
    plus: 0,
    full: 0,
  });
  const [selectedImage, setSelectedImage] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);

  useEffect(() => {
    dispatch(fetchSubscription());
  }, [dispatch]);

  useEffect(() => {
    if (allSubscription?.length != 0) {
      const filtered = allSubscription?.filter((item) => {
        const matchesPlanType =
          !filterCriteria.plan_type ||
          item.plan_name === filterCriteria.plan_type;
        const matchesSearchQuery =
          !filterCriteria.searchQuery ||
          (item.name &&
            item.name
              .toLowerCase()
              .includes(filterCriteria.searchQuery.toLowerCase()));

        return matchesPlanType && matchesSearchQuery;
      });
      setFilteredSubscriptions(filtered);
    }
  }, [filterCriteria, allSubscription]);

  useEffect(() => {
    calculateSubscriptionCounts();
  }, [allSubscription]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterCriteria((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const calculateSubscriptionCounts = () => {
    const plusCount = allSubscription.filter(
      (item) => item.plan_name === "Plus"
    ).length;
    const fullCount = allSubscription.filter(
      (item) => item.plan_name === "Full"
    ).length;
    setSubscriptionCounts({ plus: plusCount, full: fullCount });
  };

  const paginatedSubscription = filteredSubscriptions?.slice(
    currentPage * usersPerPage,
    (currentPage + 1) * usersPerPage
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleImage = (value) => {
    setSelectedImage(value?.images[0]);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div className="ct_right_content">
          <Header />
          <div className="ct_right_header">
            <div className="ct_left_header_cnt">
              <div className="form-group">
                <label for="" className="mb-2 ct_fw_600">
                  Plan Type
                </label>
                <select
                  name="plan_type"
                  value={filterCriteria.plan_type}
                  onChange={handleFilterChange}
                  className="form-control ct_input ct_pointer_curser"
                >
                  <option value="">All</option>
                  <option value="Plus">Plus</option>
                  <option value="Full">Full</option>
                </select>
              </div>
              <div className="form-group">
                <label for="" className="mb-2 ct_fw_600 ct_nbsp_none_1199">
                  &nbsp;
                </label>
                <div className="position-relative">
                  <i className="fa-solid fa-magnifying-glass ct_search_icon_12"></i>
                  <input
                    type="text"
                    className="form-control ct_input ct_text_indent_30"
                    placeholder="Search"
                    name="searchQuery"
                    value={filterCriteria.searchQuery}
                    onChange={handleFilterChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="ct_inner_dashbaord_main">
            <div className="row ">
              <div className="col-xxl-12 col-xl-12 mb-4 mb-xl-0 ">
                <div className="ct_top_sticky">
                  <div className="">
                    <div>
                      <ul className="d-flex align-items-center  gap-2 mb-0">
                        <li>
                          <h4 className="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            All Active Subscriber
                          </h4>
                        </li>
                        <li>
                          <h4 className="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            <i className="bi bi-dot"></i>
                          </h4>
                        </li>
                        <li>
                          <h4 className="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            {subscriptionCounts?.plus} Plus /{" "}
                            {subscriptionCounts?.full} Full{" "}
                          </h4>
                        </li>
                      </ul>
                    </div>
                    <div className="table-responsive">
                      <table className="table ct_custom_table">
                        <thead>
                          <tr>
                            <th>S.No.</th>
                            <th></th>
                            <th>Name & Location</th>
                            <th>Subscription started on</th>
                            <th>Subscription Expired on</th>
                            <th className="text-end">Plan</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedSubscription &&
                          paginatedSubscription != 0 ? (
                            paginatedSubscription.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <div className="d-flex align-items-center gap-2">
                                      <img
                                        src={
                                          Array.isArray(item?.images) &&
                                          item.images.length > 0
                                            ? item.images[0]
                                            : "./user_profile.png"
                                        }
                                        alt=""
                                        data-bs-toggle="modal"
                                        data-bs-target="#ct_user_img_preview"
                                        className="ct_img_56 ct_pointer_curser"
                                        onClick={() => handleImage(item)}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-flex align-items-center gap-2">
                                      <div>
                                        <h5 className="ct_fs_14 ct_fw_700 mb-0">
                                          {item?.name}
                                        </h5>
                                        <p className="mb-0 ct_fw_500">
                                          <i className="bi bi-geo-alt-fill me-1"></i>
                                          {item?.city},{item?.country}
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      {/* <p className="mb-1 ct_fw_600 ct_fs_16">
                                         Subscription started on 
                                      </p> */}
                                      <p className="mb-0 ct_fw_600 ct_fs_16">
                                        {pipViewDate2(item?.start_date)}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p className="mb-0 ct_fw_600 ct_fs_16">
                                        <span>
                                          {" "}
                                          {pipViewDate2(item?.expired_at)}
                                        </span>
                                        {/* <span className="ms-2 ct_text_op_50">
                                          {" "}
                                          5 days remaining
                                        </span> */}
                                      </p>
                                    </div>
                                  </td>
                                  <td className="text-end">
                                    <div>
                                      <p className="mb-0 ct_fw_600 ct_fs_16 ct_fw_600 ct_blue_text">
                                        {item?.plan_name}
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={6}>
                              { allSubscription.length == 0 ? (
                                    <NoRecord />
                                  ) : (
                                    <h3 className="text-center">
                                     There are no results with this search.
                                    </h3>
                                  )}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              {paginatedSubscription && paginatedSubscription?.length != 0 && (
                <>
                  <div className="d-flex justify-content-between align-items-center mt-4">
                    <div>
                      <PaginationDropdown
                        onChange={(val) => {
                          setUserPerPages(val);
                          setCurrentPage(0);
                        }}
                      />
                    </div>
                    <div>
                      <ReactPagination
                        pageCount={Math.ceil(
                          filteredSubscriptions?.length / usersPerPage
                        )}
                        onPageChange={handlePageClick}
                      />
                    </div>
                  </div>
                </>
              )}
              {/* subscription details */}
            </div>
          </div>
        </div>
      </main>

      <div
        class="modal fade ct_assets_modal"
        id="ct_user_img_preview"
        tabindex="-1"
        aria-labelledby="ct_user_img_previewLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header pb-0 border-0">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body mt-0">
              <img
                src={selectedImage || "./user_profile.png"}
                alt=""
                class="ct_img_400_big"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Subscriptions;
